import type { BrandsSelected } from "@/Models/MBrand/BrandsSelected";

type Props = {
  isFilter: boolean;
  filterData: (value: string, checked: boolean) => void;
  toggleFilter: () => void;
  datosMarcas: BrandsSelected[];
  selectBrand: string[];
};

export const FilterMovil = ({
  isFilter,
  filterData,
  toggleFilter,
  datosMarcas,
  selectBrand,
}: Props): JSX.Element => {
  const groupNames = datosMarcas.reduce<Record<string, BrandsSelected[]>>(
    (acc, marc) => {
      const brand = marc.brand;
      if (!acc[brand]) {
        acc[brand] = [];
      }
      acc[brand].push(marc);
      return acc;
    },
    {}
  );

  const handleOnChangeSelectedCheck = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, checked } = e.target;
    filterData(name, checked);
  };

  return (
    <div className={`ps-filter--sidebar ${isFilter ? "active" : ""}`}>
      <div className="ps-filter__header">
        <h3>Filtrar productos por</h3>
        <span
          className="ps-btn--close ps-btn--no-boder close-btn__develop"
          onClick={toggleFilter}></span>
      </div>
      <div className="ps-filter__content">
        <aside className="widget widget_shop">
          <h4>Marcas</h4>
          <figure className="ps-custom-scrollbar" data-height="250">
            {datosMarcas.length > 0
              ? Object.keys(groupNames).map((brand, index) => (
                  <div className="ps-checkbox" key={index}>
                    <input
                      className="form-control"
                      type="checkbox"
                      id={brand + 1}
                      name={brand}
                      onChange={handleOnChangeSelectedCheck}
                      checked={selectBrand.includes(brand)}
                    />
                    <label
                      htmlFor={brand + 1}
                      className="develop___product-title develop___Color_SalePrice__dark develop__fontFamilys">
                      {brand}
                    </label>
                  </div>
                ))
              : ""}
          </figure>
        </aside>
      </div>
    </div>
  );
};
